module.exports = __webpack_public_path__ + "img/ch09_10_学走路.561cb79f.jpg";